export default __webpack_public_path__ + "static/media/eclipse3.44e65bff.svg";